import { Badge } from 'components/Badge';
import { Typography } from 'ui/Typography';
import { IconButton } from 'ui/IconButton';
import { EditIcon } from 'components/icons/EditIcon';
import { DeleteIcon } from 'components/icons/DeleteIcon';
import { Box } from 'ui/Box';
import { FC } from 'react';

export interface QAItemProps {
  onDelete: () => void;
  onEdit: () => void;
  question: string;
  answer: string;
  category: string;
  department?: string;
}

export const QAItem: FC<QAItemProps> = ({
  onDelete,
  onEdit,
  question,
  answer,
  category,
  department,
}) => {
  return (
    <Box className="flex w-full justify-between gap-[10px] border-t pt-6">
      <Box className="flex flex-col gap-2 text-black">
        <Typography
          variant="bodyText"
          className="line-clamp-1 min-w-0 truncate text-wrap break-all font-semibold"
        >
          {question}
        </Typography>
        <Typography
          variant="bodyText"
          className="line-clamp-4 min-w-0 truncate text-wrap break-all"
        >
          {answer}
        </Typography>
        {category && (
          <Box className="mt-3 flex flex-wrap gap-2">
            <Badge name={category} cross={false} className="max-h-[26px]" />
            {department && (
              <Badge name={department} cross={false} className="max-h-[26px]" />
            )}
          </Box>
        )}
      </Box>
      <Box className="flex flex-col gap-2">
        <IconButton
          onClick={onEdit}
          className="h-8 w-8 rounded bg-light-gray p-1"
          disableRipple
        >
          <EditIcon className="h-6 w-6 fill-none text-blue" />
        </IconButton>
        <IconButton
          onClick={onDelete}
          className="h-8 w-8 rounded bg-light-gray p-1"
          disableRipple
        >
          <DeleteIcon className="h-6 w-6 text-red" />
        </IconButton>
      </Box>
    </Box>
  );
};
